var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRocket = function SvgRocket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: props.fill,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4998 9.00005C13.7683 7.1165 7.7815 9.56901 4.67326 11.6553C2.98454 12.7888 3.11641 15.0549 4.59484 16.4517L10.155 21.7046L23.4998 9.00005Z",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1132 24.5C41.3209 34.4236 38.4762 40.4532 36.2731 43.5073C35.1292 45.0929 32.963 45.0107 31.5485 43.6609L25.4541 37.8448L40.1132 24.5Z",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5906 35.2728C18.5906 31.8109 16.1889 29.4092 12.727 29.4092C9.26507 29.4092 6.86337 31.8109 6.86337 35.2728C6.86337 37.7822 7.08253 39.1957 7.25288 39.9154C7.35255 40.3365 7.66325 40.6472 8.08436 40.7469C8.80407 40.9173 10.2176 41.1364 12.727 41.1364C16.1889 41.1364 18.5906 38.7347 18.5906 35.2728Z",
    fillOpacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8084 40.2711C25.8753 40.9306 27.1161 40.7744 28.0953 39.9906C29.5072 38.8606 32.0334 36.6482 36.2838 32.3978C43.9997 24.6819 43.9998 10.5683 40.7156 7.28422C37.4314 4.00008 23.3178 4.00012 15.6019 11.716C11.3517 15.9663 9.13921 18.4925 8.00919 19.9044C7.22541 20.8837 7.06923 22.1245 7.72873 23.1915C8.72878 24.8093 10.9016 27.6975 15.6019 32.3978C20.3023 37.0982 23.1905 39.271 24.8084 40.2711ZM19 22C19 18.134 22.134 15 26 15C29.866 15 33 18.134 33 22C33 25.866 29.866 29 26 29C22.134 29 19 25.866 19 22Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26 15C22.134 15 19 18.134 19 22C19 25.866 22.134 29 26 29C29.866 29 33 25.866 33 22C33 18.134 29.866 15 26 15Z",
    fillOpacity: 0.5
  })));
};
export default SvgRocket;